import React from 'react';
import './Promo.sass';

import LinkButton from '../../Links/LinkButton';

import speakerImg from '../../../assets/img/speaker/speaker.png';

interface Props {
	buttonText: string;
	isButtonOrange: boolean;
	text: string;
	title: string;
	link: string;
	buttonId?: string;
}

function Promo({
	text,
	title,
	buttonText,
	link,
	isButtonOrange = false,
	buttonId,
}: Props) {
	return (
		<article className="uikit-card-promo">
			<picture className="uikit-card-promo__image">
				<source srcSet={speakerImg} type="image/webp" />
				<img src={speakerImg} srcSet={speakerImg} alt="This could be you!" />
			</picture>
			<h3 className="uikit-text-regular uikit-card-promo__title">{title}</h3>
			<p className="uikit-text-small uikit-card-promo__description">{text}</p>
			{/* Make this button orange by using .uikit-link-button--orange */}
			<LinkButton
				id={buttonId}
				isExternal={false}
				hrefSource={link}
				label={buttonText}
				isOrange={isButtonOrange}
			/>
		</article>
	);
}

Promo.defaultProps = {
	buttonId: '',
};

export default Promo;
